import * as React from 'react';

import { Translate } from 'react-localize-redux';

import { rgba } from 'polished';
import styled, { css } from 'styled-components';

import Box from '@components/layout/box';
import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import CircleDownloadIcon from '@components/basics/icons/circle-download';

interface SubscriptionInvoiceItemProps {
  className?: string;
  title: string;
  date: string;
  isPaid: boolean;
  onClick: () => void;
}

const SubscriptionInvoiceItem: React.FC<SubscriptionInvoiceItemProps> = (
  props
) => {
  return (
    <StyledBox className={`${props.className || ''}`}>
      <Flex alignItems="center" justifyContent="space-between">
        <InfoWrapper>
          <Typography>{props.title}</Typography>
          <Typography type="small" opacity=".5">
            {props.date}
          </Typography>
        </InfoWrapper>
        <Flex alignItems="center" justifyContent="flex-end">
          {props.isPaid ? <StyledDownloadIcon onClick={props.onClick} /> : null}
          <Tag type="small" weight="700" opacity="1" isPaid={props.isPaid}>
            <Translate
              id={
                props.isPaid
                  ? 'USER_PROFILE.SUBSCRIPTION.INVOICES.STATUS.PAID'
                  : 'USER_PROFILE.SUBSCRIPTION.INVOICES.STATUS.OVERDUE'
              }
            />
          </Tag>
        </Flex>
      </Flex>
    </StyledBox>
  );
};

export default styled(SubscriptionInvoiceItem)`
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledBox = styled(Box)`
  padding: 20px !important;
`;

const InfoWrapper = styled.div``;

const Tag = styled(Typography)<{ isPaid: boolean }>`
  user-select: none;
  padding: 4px 10px;
  border-radius: 90px;
  color: ${({ theme }) => theme.colors.error};
  background-color: ${({ theme }) => rgba(theme.colors.error, 0.3)};

  ${({ isPaid }) =>
    isPaid
      ? css`
          color: ${({ theme }) => theme.colors.success};
          background-color: ${({ theme }) =>
            rgba(theme.colors.successLight, 0.3)};
        `
      : null}
`;

const StyledDownloadIcon = styled(CircleDownloadIcon)`
  margin-right: 10px;
`;
